import { createReducer, on } from '@ngrx/store';
import { BillToAccounts, GetBrandBillingConfigResponse } from '../../proto';
import {
  actionBillToAccountsGet,
  actionBillToAccountsGetSuccess,
  actionBillToAccountsGetFailure,
  actionBillToAccountsGetDestroy,
  actionBrandConfigBillingsGet,
  actionBrandConfigBillingsGetSuccess,
  actionBrandConfigBillingsGetFailure,
  actionBrandConfigBillingsGetDestroy,
  actionBillingDestroy,
} from 'src/app/core/store/billings/billings.action';

export interface BillingsState {
  billToAccountsList?: BillToAccounts[];
  billToAccountsBrandList?: BillToAccounts[];
  brandConfigBillings?: GetBrandBillingConfigResponse;
  isLoadingBillToAccounts: Boolean;
  isLoadingBrandConfigBillings: Boolean;
}

const initialState: BillingsState = {
  billToAccountsList: undefined,
  billToAccountsBrandList: undefined,
  brandConfigBillings: undefined,
  isLoadingBillToAccounts: false,
  isLoadingBrandConfigBillings: false,
};

export const billingsReducer = createReducer(
  initialState,
  on(actionBillToAccountsGet, (state, action) => {
    return {
      ...state,
      isLoadingBillToAccounts: true,
    };
  }),
  on(actionBillToAccountsGetSuccess, (state, action) => {
    return {
      ...state,
      billToAccountsList: action.billToAccounts,
      billToAccountsBrandList: action.billToAccountsBrand,
      isLoadingBillToAccounts: false,
    };
  }),
  on(actionBillToAccountsGetFailure, (state, action) => {
    return {
      ...state,
      billToAccountsList: undefined,
      billToAccountsBrandList: undefined,
      isLoadingBillToAccounts: false,
    };
  }),
  on(actionBillToAccountsGetDestroy, (state, action) => {
    return {
      ...state,
      billToAccountsList: undefined,
    };
  }),

  on(actionBrandConfigBillingsGet, (state, action) => {
    return {
      ...state,
      isLoadingBrandConfigBillings: true,
    };
  }),
  on(actionBrandConfigBillingsGetSuccess, (state, action) => {
    return {
      ...state,
      isLoadingBrandConfigBillings: false,
      brandConfigBillings: action.payload,
    };
  }),
  on(actionBrandConfigBillingsGetFailure, (state, action) => {
    return {
      ...state,
      isLoadingBrandConfigBillings: false,
      brandConfigBillings: undefined,
    };
  }),
  on(actionBrandConfigBillingsGetDestroy, (state, action) => {
    return {
      ...state,
      brandConfigBillings: undefined,
    };
  }),

  on(actionBillingDestroy, () => {
    return initialState;
  })
);
